// extracted by mini-css-extract-plugin
export default {"show-card-detail":"HomeStyles_show-card-detail__-5NWY","project-card":"HomeStyles_project-card__lx-6w","menu-item-mobile":"HomeStyles_menu-item-mobile__O6anC"};